'use client';

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { Separator } from '../ui/separator';
import { ProductUserReview } from './product-user-review';
import { ProductDetailsReviewSummary } from './product-details-review-summary';
import { trpc } from '~/trpc/client';
import { Button } from '../ui/button';
import Image from 'next/image';

type ProductDetailsReviewsAccordionProps = {
  trustPilotSku: string;
};

export function ProductDetailsReviewsAccordion({
  trustPilotSku,
}: ProductDetailsReviewsAccordionProps) {
  const trustpilot = trpc.trustpilot.getProductReviews.useInfiniteQuery(
    {
      itemCode: trustPilotSku,
      perPage: 5,
    },
    {
      getNextPageParam: (lastPage) => {
        console.log({ cursor: lastPage?.nextCursor ?? null });
        return lastPage?.nextCursor ?? null;
      },
    },
  );

  const reviewSummary =
    trustpilot.data?.pages[0]?.reviews?.productReviewSummary;

  const reviewCount = reviewSummary?.numberOfReviews.total;

  return (
    <AccordionItem
      value={'reviews'}
      className="border-neutral-300"
      id="product-reviews"
    >
      <AccordionTrigger
        className="py-3.5 leading-6"
        id="product-reviews-trigger"
      >
        Reviews {reviewCount ? `(${reviewCount})` : null}
      </AccordionTrigger>
      <AccordionContent className="space-y-4">
        {trustpilot.isLoading ? (
          <div className="flex h-20 items-center justify-center">
            <p className="text-sm text-neutral-500">Loading...</p>
          </div>
        ) : null}
        <>
          {reviewSummary ? (
            <>
              <ProductDetailsReviewSummary summary={reviewSummary} />
              <Separator className="h-[2px]" />
            </>
          ) : null}

          <div className="space-y-4">
            {/* <h3 className="mb-2 text-lg font-semibold">Customer Reviews</h3> */}
            <p className="mb-4 flex items-center font-semibold">
              Showing our latest reviews{' '}
              <Image
                unoptimized
                className="ml-auto inline-block w-24"
                width={1132.8}
                height={278.2}
                src="/images/trustpilot/Trustpilot_brandmark_gr-blk-RGB.svg"
                alt="Trustpilot"
              />
            </p>
            <div className="grid grid-cols-[6rem,1fr] gap-4 sm:grid-cols-[max-content,1fr]">
              {trustpilot.data?.pages.map((page) =>
                page?.reviews?.productReviews.map((review) => (
                  <ProductUserReview
                    key={review.userFriendlyCreatedDate + review.consumerName}
                    review={review}
                  />
                )),
              )}
            </div>
            <div className="mt-4 flex items-center justify-center">
              {trustpilot.hasNextPage && (
                <Button
                  variant="link"
                  onClick={() => trustpilot.fetchNextPage()}
                  className="items-center gap-2"
                >
                  Load more reviews
                </Button>
              )}
            </div>
          </div>
        </>
      </AccordionContent>
    </AccordionItem>
  );
}
